import { call, put, take, fork } from 'redux-saga/effects'
import actionTypes from 'redux/actions/actionTypes'
import { foldersSync } from 'sync'

function *getColors() {
	while (true) {
		yield take([actionTypes.PRIVATE_LIBRARY_INITIALIZE_LIBRARY_BASE, actionTypes.MY_LIBRARY_INITIALIZE])
		const response = yield call(foldersSync.getColors)
		if (response.error_code === 0) {
			yield put({
				type: actionTypes.FOLDERS_GET_COLORS_SUCCESS,
				payload: response.payload,
			})
			yield take([actionTypes.FOLDERS_RESET_COLORS])
		} else {
			yield put({
				type: actionTypes.SYNC_UNCAUGHT_ERROR,
				payload: response.payload,
			})
		}
	}
}

export default [
	fork(getColors),
]
